import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import {
  IChangeVacancyApplicationStatus,
  ICreateVacancyApplicationComment,
  IVacancyApplication,
  IVacancyApplicationCreate,
  IVacancyApplicationEvent,
} from "./types";

export const getVacancyApplications = (): AxiosPromise<IVacancyApplication[]> =>
  axiosInstance.get(
    "/vacancy-applications?expand=vacancy.customer,vacancy.project,vacancy.recruiters"
  );

export const getVacancyApplicationById = (
  id: string
): AxiosPromise<IVacancyApplication> =>
  axiosInstance.get(`/vacancy-application/${id}/view?expand=vacancy.customer,vacancy.project,vacancy.recruiters,candidate.expected_salary,
    candidate.grade,candidate.country,candidate.town,candidate.contact_email,candidate.contact_phone,candidate.contact_telegram, candidate.last_name, candidate.first_name, candidate.patronymic_name,
    candidate.contact_whatsapp,candidate.contacts,candidate.birthday,candidate.internal_rate,candidate.source,events,comments,events.created_by,events.scheduled_at, events.reason,created_by,attachments, created_at`);

export const createVacancyApplication = (
  params: IVacancyApplicationCreate
): AxiosPromise<IVacancyApplication> =>
  axiosInstance.post(`/vacancy-application/create`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const createCommentVacancyApplication = (
  id: string,
  params: ICreateVacancyApplicationComment
): AxiosPromise<IVacancyApplicationEvent> =>
  axiosInstance.post(
    `/vacancy-application/${id}/add-comment`,
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const changeStatusVacancyApplication = (
  id: string,
  params: IChangeVacancyApplicationStatus
): AxiosPromise<IVacancyApplicationEvent> =>
  axiosInstance.post(
    `/vacancy-application/${id}/change-status`,
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const updateEventVacancyApplication = (
  id: string,
  params: IChangeVacancyApplicationStatus
): AxiosPromise<IVacancyApplicationEvent> =>
  axiosInstance.post(
    `/vacancy-application/update-event/${id}`,
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const deleteEventVacancyApplication = (
  id: string
): AxiosPromise<undefined> =>
  axiosInstance.post(`/vacancy-application/delete-event/${id}`);

export const addAnnexFiles = (
  id: string,
  params: { attachments: File }
): AxiosPromise<undefined> =>
  axiosInstance.post(
    `/vacancy-application/${id}/attach-files`,
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const deleteAnnexFiles = (
  id: string,
  params: { attachments_delete: string[] }
): AxiosPromise<undefined> =>
  axiosInstance.post(
    `/vacancy-application/${id}/delete-files`,
    params
  );

  export const deleteVacancyApplication = (
    id: string
  ): AxiosPromise<undefined> =>
    axiosInstance.post(`/vacancy-application/${id}/delete`);
